import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { TileLayerManager } from "../manager/layerManager";
import { Base } from "./base";
import { setSelect, setHighlight, setPickState as _setPickState, clearPickState as _clearPickState } from "../interaction/utils";
export var TileLayer = /*#__PURE__*/function (_Base) {
  _inherits(TileLayer, _Base);

  var _super = _createSuper(TileLayer);

  function TileLayer(_ref) {
    var _parentSource$data;

    var _this;

    var parent = _ref.parent,
        rendererService = _ref.rendererService,
        mapService = _ref.mapService,
        layerService = _ref.layerService,
        pickingService = _ref.pickingService,
        transforms = _ref.transforms;

    _classCallCheck(this, TileLayer);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "pickColors", {
      select: null,
      active: null
    });

    var parentSource = parent.getSource();

    var _ref2 = (parentSource === null || parentSource === void 0 ? void 0 : (_parentSource$data = parentSource.data) === null || _parentSource$data === void 0 ? void 0 : _parentSource$data.tilesetOptions) || {},
        sourceLayer = _ref2.sourceLayer;

    _this.sourceLayer = sourceLayer;
    _this.parent = parent;
    _this.mapService = mapService;
    _this.layerService = layerService;
    _this.tileLayerManager = new TileLayerManager(parent, mapService, rendererService, pickingService, transforms);

    _this.initTileSetManager();

    _this.bindSubLayerEvent();

    _this.bindSubLayerPick();

    _this.scaleField = _this.parent.getScaleOptions();
    return _this;
  }

  _createClass(TileLayer, [{
    key: "children",
    get: function get() {
      return this.tileLayerManager.children;
    }
  }, {
    key: "clearPick",
    value: function clearPick(type) {
      // Tip: 瓦片只有在 mousemove 的时候需要设置清除
      if (type === 'mousemove') {
        this.tileLayerManager.tilePickService.clearPick();
      }
    }
    /**
     * 清除 select 的选中状态
     */

  }, {
    key: "clearPickState",
    value: function clearPickState() {
      _clearPickState(this.children);
    }
    /**
     * 瓦片图层独立的拾取逻辑
     * @param target
     * @returns
     */

  }, {
    key: "pickLayers",
    value: function pickLayers(target) {
      return this.tileLayerManager.pickLayers(target);
    }
  }, {
    key: "setPickState",
    value: function setPickState(layers) {
      _setPickState(layers, this.pickColors);
    }
  }, {
    key: "bindSubLayerPick",
    value: function bindSubLayerPick() {
      var _this2 = this;

      this.tileLayerManager.tilePickService.on('pick', function (e) {
        // @ts-ignore
        var _e$pickedColors = _slicedToArray(e.pickedColors, 3),
            r = _e$pickedColors[0],
            g = _e$pickedColors[1],
            b = _e$pickedColors[2];

        if (e.type === 'click') {
          var restLayers = _this2.children.filter(function (child) {
            return child.inited && child.isVisible() && child.isVector;
          }).filter(function (child) {
            return child !== e.layer;
          });

          var renderList = _this2.layerService.getRenderList();

          var color = setSelect(restLayers, [r, g, b], renderList);
          _this2.pickColors.select = color;
        } else {
          setHighlight(_this2.children, [r, g, b]);
          _this2.pickColors.active = [r, g, b];
        }
      });
      this.tileLayerManager.tilePickService.on('unpick', function () {
        _this2.pickColors.active = null;
      });
    }
  }, {
    key: "bindSubLayerEvent",
    value: function bindSubLayerEvent() {
      var _this3 = this;

      /**
       * layer.on('click', (ev) => {}); // 鼠标左键点击图层事件
       * layer.on('mouseenter', (ev) => {}); // 鼠标进入图层要素
       * layer.on('mousemove', (ev) => {}); // 鼠标在图层上移动时触发
       * layer.on('mouseout', (ev) => {}); // 鼠标移出图层要素时触发
       * layer.on('mouseup', (ev) => {}); // 鼠标在图层上单击抬起时触发
       * layer.on('mousedown', (ev) => {}); // 鼠标在图层上单击按下时触发
       * layer.on('contextmenu', (ev) => {}); // 图层要素点击右键菜单
       *
       *  鼠标在图层外的事件
       * layer.on('unclick', (ev) => {}); // 图层外点击
       * layer.on('unmousemove', (ev) => {}); // 图层外移动
       * layer.on('unmouseup', (ev) => {}); // 图层外鼠标抬起
       * layer.on('unmousedown', (ev) => {}); // 图层外单击按下时触发
       * layer.on('uncontextmenu', (ev) => {}); // 图层外点击右键
       * layer.on('unpick', (ev) => {}); // 图层外的操作的所有事件
       */
      this.parent.on('subLayerClick', function (e) {
        _this3.parent.emit('click', _objectSpread({}, e));
      });
      this.parent.on('subLayerMouseMove', function (e) {
        return _this3.parent.emit('mousemove', _objectSpread({}, e));
      });
      this.parent.on('subLayerMouseUp', function (e) {
        return _this3.parent.emit('mouseup', _objectSpread({}, e));
      });
      this.parent.on('subLayerMouseEnter', function (e) {
        return _this3.parent.emit('mouseenter', _objectSpread({}, e));
      });
      this.parent.on('subLayerMouseOut', function (e) {
        return _this3.parent.emit('mouseout', _objectSpread({}, e));
      });
      this.parent.on('subLayerMouseDown', function (e) {
        return _this3.parent.emit('mousedown', _objectSpread({}, e));
      });
      this.parent.on('subLayerContextmenu', function (e) {
        return _this3.parent.emit('contextmenu', _objectSpread({}, e));
      }); // vector layer 图层外事件

      this.parent.on('subLayerUnClick', function (e) {
        return _this3.parent.emit('unclick', _objectSpread({}, e));
      });
      this.parent.on('subLayerUnMouseMove', function (e) {
        return _this3.parent.emit('unmousemove', _objectSpread({}, e));
      });
      this.parent.on('subLayerUnMouseUp', function (e) {
        return _this3.parent.emit('unmouseup', _objectSpread({}, e));
      });
      this.parent.on('subLayerUnMouseDown', function (e) {
        return _this3.parent.emit('unmousedown', _objectSpread({}, e));
      });
      this.parent.on('subLayerUnContextmenu', function (e) {
        return _this3.parent.emit('uncontextmenu', _objectSpread({}, e));
      });
    }
  }]);

  return TileLayer;
}(Base);